import script from "./LoginLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginLink.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__